export default __webpack_public_path__ + "static/media/fb.bfd45e5d.png";